import axios from 'axios'

export const fetchGamePackages = async () => {
  return await axios.get(`v1/games`)
};
